import {
  Dispatch,
  FC,
  Fragment,
  ReactElement,
  Ref,
  forwardRef,
  useEffect,
  useState,
} from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  Select,
  Slide,
  TextField,
} from "@mui/material";
import { useStyles } from "../styles";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CheckIcon from "@mui/icons-material/Check";
import { DataRef } from "../../../types/DataRef";
import { AlertType } from "../../../types/AlertType";
import { AxiosInstance } from "axios";
import CheckAttr from "../../../utils/CheckAttr";
import { DataCout } from "../../content/parametrage/Cout/Cout";
import dateFormat from "dateformat";
import { TransitionProps } from "@mui/material/transitions";

interface CoutToSave {
  id?: number;
  pays?: number;
  bu?: number;
  client?: number;
  operation?: number;
  article?: number;
  date_debut_initial?: Date;
  date_debut?: Date;
  coutactivite: string;
}

interface InputValidation {
  pays: boolean;
  bu: boolean;
  client: boolean;
  operation: boolean;
  article: boolean;
  date_debut: boolean;
  coutactivite: boolean;
}

interface UpdateCoutFormProps {
  onClose: () => void;
  cout: DataCout;
  openModal: boolean;
  openModalDup: boolean;
  dataPays: DataRef[];
  http: AxiosInstance;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
  reloadList: () => void;
}

const resetCoutToSave: CoutToSave = {
  id: undefined,
  pays: undefined,
  bu: undefined,
  client: undefined,
  article: undefined,
  operation: undefined,
  date_debut: undefined,
  coutactivite: "",
};

const resetInpuValidation: InputValidation = {
  pays: false,
  bu: false,
  client: false,
  operation: false,
  article: false,
  date_debut: false,
  coutactivite: false,
};

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UpdateCoutForm: FC<UpdateCoutFormProps> = ({
  dataPays,
  cout,
  openModal,
  openModalDup,
  onClose,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  reloadList,
  http,
}) => {
  const classes = useStyles();

  const [isClickSave, setIsClickSave] = useState<boolean>(false);
  const [dialogLoading, setDialogLoading] = useState<boolean>(false);
  const [
    isSaisieManagerExistInDateInterval,
    setIsSaisieManagerExistInDateInterval,
  ] = useState<boolean>(false);

  const [dataBu, setDataBu] = useState<DataRef[]>([]);
  const [dataClients, setDataClients] = useState<DataRef[]>([]);
  const [dataOperations, setDataOperations] = useState<DataRef[]>([]);
  const [dataArticles, setDataArticles] = useState<DataRef[]>([]);
  const [coutToSave, setCoutToSave] = useState<CoutToSave>(resetCoutToSave);
  const [errorInput, setErrorInput] =
    useState<InputValidation>(resetInpuValidation);

  const [parentDateDebut, setParentDateDebut] = useState<Date | undefined>();

  const initial_date_fin = cout?.date_fin;

  console.log(parentDateDebut);
  useEffect(() => {
    if (cout) {
      const coutToUpdate: CoutToSave = {
        id: cout.id,
        pays: cout?.pays_id,
        bu: cout?.bu_id,
        client: cout?.client_id,
        operation: cout?.operation_id,
        article: cout?.article_id,
        date_debut_initial: openModalDup ? cout?.date_debut : undefined,
        date_debut: cout?.date_debut,
        coutactivite: cout?.cout,
      };

      setDataBu([
        {
          id: cout?.bu_id,
          libelle: cout?.bu_libelle,
        },
      ]);

      setDataClients([
        {
          id: cout?.client_id,
          libelle: cout?.client_libelle,
        },
      ]);

      setDataOperations([
        {
          id: cout?.operation_id,
          libelle: cout?.operation_libelle,
        },
      ]);

      setDataArticles([
        {
          id: cout?.article_id,
          libelle: cout?.article_libelle,
        },
      ]);

      setCoutToSave(coutToUpdate);
    }

    if (openModal) {
      http
        .get(`article/get-date-debut-parent-for/Cout/${cout?.id}`)
        .then((res) => {
          setParentDateDebut(res.data);
        })
        .catch((error) => {
          console.log(error);
          setAlertType("error");
          setOpenSnack(true);
        });
    }

    if (openModalDup) {
      setParentDateDebut(cout?.date_debut);
    }
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setCoutToSave({
      ...coutToSave,
      [name]: value,
    });
  };

  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    setErrorInput(resetInpuValidation);

    if (
      !CheckAttr(coutToSave?.pays) ||
      !CheckAttr(coutToSave?.bu) ||
      !CheckAttr(coutToSave?.client) ||
      !CheckAttr(coutToSave?.operation) ||
      !CheckAttr(coutToSave?.date_debut) ||
      !CheckAttr(coutToSave?.coutactivite)
    ) {
      if (!CheckAttr(coutToSave?.pays)) {
        setErrorInput((prev: InputValidation) => ({ ...prev, pays: true }));
      }

      if (!CheckAttr(coutToSave?.bu)) {
        setErrorInput((prev: InputValidation) => ({ ...prev, bu: true }));
      }

      if (!CheckAttr(coutToSave?.client)) {
        setErrorInput((prev: InputValidation) => ({ ...prev, client: true }));
      }

      if (!CheckAttr(coutToSave?.operation)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          operation: true,
        }));
      }

      if (!CheckAttr(coutToSave?.date_debut)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          date_debut: true,
        }));
      }

      if (!CheckAttr(coutToSave?.coutactivite)) {
        setErrorInput((prev: InputValidation) => ({ ...prev, value: true }));
      }

      setAlerteMessage("Merci de remplir les champs en rouge SVP!");
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    }
    return true;
  };

  const handleUpdate = (withLoader: boolean = false) => {
    withLoader && setDialogLoading(true);
    http
      .put(`cout/update/${cout?.id}`, coutToSave)
      .then(() => {
        setAlerteMessage("Enregistrement efféctuée !");
        setAlertType("success");
        setOpenSnack(true);
        onClose();
        reloadList();
      })
      .catch((error) => {
        console.log(error);
        setAlertType("error");
        setOpenSnack(true);
      })
      .finally(() => {
        setIsClickSave(false);
        setDialogLoading(false);
      });
  };

  const handleDuplicate = () => {
    http
      .post("cout/duplicate", coutToSave)
      .then(() => {
        setAlerteMessage("Duplication efféctuée !");
        setAlertType("success");
        setOpenSnack(true);
        onClose();
        reloadList();
      })
      .catch((error) => {
        console.log(error);
        setAlertType("error");
        setOpenSnack(true);
      })
      .finally(() => {
        setIsClickSave(false);
        setDialogLoading(false);
      });
  };

  const handleSave = () => {
    if (isValidate()) {
      setIsClickSave(true);
      // Cas modification
      if (openModal) {
        handleUpdate();
      }

      // Cas duplication
      if (openModalDup) {
        handleDuplicate();
      }
    }
  };

  const minDate = (): string => {
    const min = openModalDup ? coutToSave?.date_debut_initial : parentDateDebut;

    const date = new Date(String(min));
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return `${year}-${month}-${day.toString().padStart(2, "0")}`;
  };

  return (
    <Fragment>
      <Box className={classes.root}>
        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="pays"
                color="warning"
                shrink={CheckAttr(coutToSave?.pays)}
              >
                Pays de production
              </InputLabel>
              <Select
                id="pays"
                native
                color="warning"
                disabled
                error={errorInput.pays}
                value={coutToSave?.pays}
                onChange={handleChange}
                label="Pays de production"
                inputProps={{
                  name: "pays",
                }}
              >
                <option value=""></option>
                {dataPays.map((pays) => (
                  <option key={pays?.id} value={pays?.id}>
                    {pays?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="bu"
                color="warning"
                shrink={CheckAttr(coutToSave?.bu)}
              >
                Business Unit
              </InputLabel>
              <Select
                id="bu"
                native
                color="warning"
                disabled
                error={errorInput.bu}
                value={coutToSave?.bu}
                onChange={handleChange}
                label="Business Unit"
                inputProps={{
                  name: "bu",
                }}
              >
                <option value=""></option>
                {dataBu.map((bu) => (
                  <option key={bu?.id} value={bu?.id}>
                    {bu?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="client"
                color="warning"
                shrink={CheckAttr(coutToSave?.client)}
              >
                Client
              </InputLabel>
              <Select
                id="client"
                native
                color="warning"
                disabled
                error={errorInput.client}
                value={coutToSave?.client}
                onChange={handleChange}
                label="Client"
                inputProps={{
                  name: "client",
                }}
              >
                <option value=""></option>
                {dataClients.map((client) => (
                  <option key={client?.id} value={client?.id}>
                    {client?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="operation"
                color="warning"
                shrink={CheckAttr(coutToSave?.operation)}
              >
                Opération
              </InputLabel>
              <Select
                id="operation"
                native
                color="warning"
                disabled
                error={errorInput.operation}
                value={coutToSave?.operation}
                onChange={handleChange}
                label="Opération"
                inputProps={{
                  name: "operation",
                }}
              >
                <option value=""></option>
                {dataOperations.map((operation) => (
                  <option key={operation?.id} value={operation?.id}>
                    {operation?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="operation"
                color="warning"
                shrink={CheckAttr(coutToSave?.article)}
              >
                Article
              </InputLabel>
              <Select
                id="article"
                native
                color="warning"
                disabled
                error={errorInput.article}
                value={coutToSave?.article}
                onChange={handleChange}
                label="Article"
                inputProps={{
                  name: "article",
                }}
              >
                <option value=""></option>
                {dataArticles.map((article) => (
                  <option key={article?.id} value={article?.id}>
                    {article?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
            <TextField
              name="date_debut"
              label="Date debut"
              type="date"
              color="warning"
              disabled={openModal === true && cout?.couts_parent_id === null}
              fullWidth
              error={errorInput.date_debut}
              value={coutToSave?.date_debut}
              inputProps={{
                // min: minDate()
                min: parentDateDebut,
              }}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              name="coutactivite"
              label="Coût activité"
              color="warning"
              fullWidth
              autoComplete="off"
              type="number"
              placeholder="Ex: 2.02"
              inputProps={{
                step: 0.01,
                lang: "en-US",
              }}
              error={errorInput.coutactivite}
              value={coutToSave?.coutactivite}
              onChange={handleChange}
              InputLabelProps={{
                shrink: CheckAttr(coutToSave?.coutactivite),
              }}
            />
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="center" mt={5}>
          <LoadingButton
            onClick={() => handleSave()}
            endIcon={<SaveIcon />}
            loading={isClickSave}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
          >
            Enregistrer
          </LoadingButton>
        </Box>
      </Box>
      <Dialog
        open={isSaisieManagerExistInDateInterval}
        TransitionComponent={Transition}
        maxWidth="xs"
        keepMounted
        onClose={(e) => setIsSaisieManagerExistInDateInterval(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Il existe déjà des heures saisis pour les intervalles de dates du{" "}
            {/* {dateFormat(coutToSave.date_fin, 'dd-mm-yyyy')} */} au{" "}
            {dateFormat(initial_date_fin, "dd-mm-yyyy")}.
            <br />
            <br />
            Voulez-vous continuer ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box mr={2.5}>
            <LoadingButton
              onClick={() => handleUpdate(true)}
              startIcon={<CheckIcon />}
              loadingPosition="end"
              sx={{ textTransform: "none", mr: 2 }}
              variant="contained"
              color="warning"
              size="small"
              loading={dialogLoading}
            >
              Oui
            </LoadingButton>
            <Button
              onClick={(e) => setIsSaisieManagerExistInDateInterval(false)}
              variant="contained"
              color="inherit"
              size="small"
              sx={{ textTransform: "none" }}
              startIcon={<ExitToAppIcon />}
            >
              Non
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default UpdateCoutForm;
